import { Box, Button, Collapse, Flex, Heading, Text } from "@chakra-ui/react";
import "react-datepicker/dist/react-datepicker.css";
import { Tag } from "../models/Filter";
import GeneralTagFilter from "./GeneralTagFilter";
import { useMediaQuery } from "react-responsive";
import TagFilter from "./TagFilter";
import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

const VISIBLE_FILTER_TYPES = [
  "cvfRef",
  "rclientRef",
  "responsible",
  "status",
  "supplier",
];

const Filter = ({
  extraFilters = [],
  visibleExtraFilters = [],
  vertical = false,
  tagFilter = false,
  tags,
  setTags,
  types = [
    { label: "Nº do processo", type: "cvfRef" },
    { label: "NCM", type: "ncm" },
    { label: "Origem", type: "origin" },
    { label: "Fornecedor", type: "supplier" },
    { label: "Produto", type: "product" },
    { label: "Responsável", type: "responsible" },
  ],
}: {
  extraFilters?: any[];
  visibleExtraFilters?: any[];
  vertical?: boolean;
  tagFilter?: boolean;
  tags: Tag[];
  setTags: any;
  types?: { label: string; type: string }[];
}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [showAdvanced, setShowAdvanced] = useState(false);

  const visibleTypes = VISIBLE_FILTER_TYPES.map((type) =>
    types.find((e) => e.type === type),
  ).filter(Boolean) as { label: string; type: string }[];
  const hiddenTypes = types.filter(
    (type) => !VISIBLE_FILTER_TYPES.includes(type.type),
  );
  const hasAdvancedFilters = hiddenTypes.length > 0 || extraFilters.length > 0;
  return (
    <Box w="100%">
      <Heading size="lg" fontWeight="semibold" marginBottom="4px">
        Filtros
      </Heading>
      <Text fontSize="17px" marginBottom="24px">
        Faça o filtro de acordo com as informações que você deseja visualizar
      </Text>
      {tagFilter ? (
        <GeneralTagFilter {...{ types, tags, setTags }} />
      ) : (
        <Box w="100%">
          <Flex
            flexDirection={isMobile || vertical ? "column" : "row"}
            gap={vertical ? 0 : "32px"}
            w="100%"
            wrap="wrap"
          >
            {visibleTypes.map((visibleType) => (
              <TagFilter
                key={visibleType.type}
                {...{ tags, setTags }}
                label={visibleType.label}
                type={visibleType.type}
              />
            ))}
            {visibleExtraFilters.map((visibleExtraFilter, index) => (
              <Box key={index}>{visibleExtraFilter}</Box>
            ))}
          </Flex>

          {hasAdvancedFilters && (
            <>
              <Collapse in={showAdvanced} animateOpacity>
                <Box
                  style={{
                    marginTop: "32px",
                    borderColor: "var(--icon-color)",
                    borderTopWidth: "0.7px",
                  }}
                />
                <Flex
                  flexDirection={isMobile || vertical ? "column" : "row"}
                  gap={vertical ? 0 : "32px"}
                  w="100%"
                  wrap="wrap"
                  mt="32px"
                >
                  {hiddenTypes.map((t) => (
                    <TagFilter
                      key={t.type}
                      {...{ tags, setTags }}
                      label={t.label}
                      type={t.type}
                    />
                  ))}
                  {extraFilters.map((extraFilter, index) => (
                    <Box key={index}>{extraFilter}</Box>
                  ))}
                </Flex>
              </Collapse>

              <Button
                variant="ghost"
                color="var(--icon-color)"
                mt="16px"
                px={0}
                rightIcon={
                  showAdvanced ? <ChevronUpIcon /> : <ChevronDownIcon />
                }
                onClick={() => setShowAdvanced((prev) => !prev)}
                _hover={{ background: "transparent", opacity: 0.8 }}
              >
                {showAdvanced
                  ? "Ocultar filtros avançados"
                  : "Filtros avançados"}
              </Button>
            </>
          )}

          {tags.length > 0 && (
            <Button
              backgroundColor="var(--icon-color)"
              color="white"
              my="24px"
              onClick={() => setTags([])}
            >
              Limpar filtros
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Filter;
